var FilterSendRequest = require('./filter-send-request');

var OptionsSerialiser = require('./send-options-serialiser');
var ContentSerialiser = require('content/serialiser');
var CIDSerialiser = require('conversation/conversation-id-serialiser');

var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var filter = Codec.readString(input);
        var path = Codec.readString(input);
        var content = ContentSerialiser.read(input);
        var options = OptionsSerialiser.read(input);
        var cid = CIDSerialiser.read(input);
        return {
            cid : cid,
            path : path,
            filter : filter,
            message : content,
            options : options
        };
    },
    write : function(output, req) {
        Codec.writeString(output, req.filter);
        Codec.writeString(output, req.path);
        ContentSerialiser.write(output, req.content);
        OptionsSerialiser.write(output, req.options);
        CIDSerialiser.write(output, req.cid);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/filter-send-request-serialiser.js
// module id = 1696
// module chunks = 1